import { curryN } from "ramda";
import getWithToken from "./base/get-with-token";

const getCustomerPressureUsage = curryN(2, (id, query) =>
  getWithToken(`/customer/${id}/pressure-usage`)(query)
);

export default getCustomerPressureUsage;
